import { Link } from "react-router-dom";

export default function LogoMark({ compact = false, to = "/" }) {
  return (
    <Link to={to} className="logo-mark logo-mark--clickable" aria-label="Go to TAZY CART marketplace home">
      <img src="/tazy-logo.jpeg" alt="TAZY CART" />
      {!compact && (
        <div>
          <strong>TAZY CART</strong>
          <span>Shop smart. Live better.</span>
        </div>
      )}
    </Link>
  );
}
